/**
 * @file
 * A JavaScript file for Location detail pages.
 *
 * @copyright Copyright 2020 Palantir.net
 *
 */

// eslint-disable-next-line func-names
(function ($) {
  // Append alert and CTA blocks on Location nodes on top of the page for mobile.
  Drupal.behaviors.providerAppointmentCard = {
    attach() {
      if ($("body").hasClass("page-node-physician")) {
        let windowsize = $(window).width();
        if (windowsize < 1040) {
          $(".availability-preview").prependTo(".l-main");
        }

        $(window).resize(() => {
          windowsize = $(window).width();
          if (windowsize < 1040) {
            $(".availability-preview").prependTo(".l-main");
          } else {
            $(".availability-preview").prependTo(".l-sidebar");
          }
        });
      }
    }
  };

})(jQuery);
